import { render, staticRenderFns } from "./ChannelManagement.vue?vue&type=template&id=7307382d&scoped=true&"
import script from "./ChannelManagement.vue?vue&type=script&lang=js&"
export * from "./ChannelManagement.vue?vue&type=script&lang=js&"
import style0 from "./ChannelManagement.vue?vue&type=style&index=0&id=7307382d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7307382d",
  null
  
)

export default component.exports